import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import Button from 'discada/dist/Button'
import Icon from 'discada/dist/Icon'
import get from 'lodash/get'

import DealTuner from 'components/Quote/DealTuner'
import DealRoad from 'components/Quote/DealRoad'
import { getQueryValue } from 'selectors/pageStateSelectors'
import { DirtyMask } from 'components/widgets/Dirty'

import Trades from 'components/Quote/Trades'
import Rebates from 'components/Quote/Rebates'
import ProgramChart from 'components/Quote/ProgramChart'
import Additions from 'components/config/quote/Additions'
import MaintenancePlans from 'components/config/quote/MaintenancePlans'
import Fees from 'components/config/quote/Fees'
import Warranties from 'components/config/quote/Warranties'
import Discounts from 'components/config/quote/Discounts'
import Survey from 'components/Quote/Survey'
import ProgramInfo from 'components/Quote/ProgramInfo'
import Pricing from 'components/VRP/Pricing'
import Interactions from 'components/Quote/Interactions'
import SavedMessage, { VehicleLink } from 'components/Quote/SavedMessage'
import QuoteSaveForm from 'components/forms/QuoteSaveForm'

import { getHasMdrive } from 'selectors/appStatusSelectors'
import { INTENTS } from 'reducers/quoteReducers'

import {
  isQuotePersisted,
  getQuoteValue,
  getBestProgram,
  getQuoteShortLink,
  isProgramExpired,
} from 'selectors/quoteSelectors'

import { addItem, removeItem, updateQuote } from 'actions/quoteActions'
import {
  addAndReplacePageState,
  removeFromPageState,
} from 'actions/pageStateActions'

import './DealWorkArea.scss'

export class DealWorkArea extends React.Component {
  constructor(...args) {
    super(...args)

    this.popContract = async () => {
      this.props.addAndReplacePageState({
        contractDetails: this.props.mode,
        autoPrint: true,
      })
    }

    this.closeContract = () => {
      setTimeout(
        () => this.props.removeFromPageState('contractDetails', true),
        1,
      )
    }
  }

  componentDidMount() {
    window.addEventListener('afterprint', this.closeContract)
  }

  componentWillUnmount() {
    window.removeEventListener('afterprint', this.closeContract)
  }

  render() {
    let props = this.props,
      {
        className,
        activeSection,
        showInteractions,
        quoteShortLink,
        isSelectedProgramExpired,
      } = props

    let printHeader = (
      <div className="program-info-header">
        <Button onClick={this.popContract} icon="print">
          Print&hellip;
        </Button>
      </div>
    )

    return (
      <div
        className={c(
          'deal-work-area',
          className,
          `deal-work-area-${activeSection}`,
        )}
      >
        <DealTuner {...props} />
        <DealRoad {...props} />

        {activeSection && (
          <div className={c('deal-work-area-inner')}>
            {activeSection === 'fandi' && <Tweak {...props} />}
            {activeSection === 'trades' && <Trades {...props} showAcv />}
            {activeSection === 'rebates' && (
              <div className="presentation-info-wrapper">
                <RebatesAndDiscounts {...props} />
                <Rebates {...props} getDealerCash />
              </div>
            )}
            {activeSection === 'presentation' && (
              <div className="presentation-config-wrapper">
                <Pricing {...props} />
                <Survey
                  {...props}
                  withConfig
                  manager
                  noFilter
                  allowCustom={false}
                  showDiff
                />

                {isSelectedProgramExpired && (
                  <div className="expiration-warning">
                    <span>
                      <Icon icon="asterisk" /> This program has expired. New
                      programs for this car are arriving soon.
                    </span>
                  </div>
                )}
              </div>
            )}
            {activeSection === 'programs' && <ProgramChart {...props} />}
            {activeSection === 'contract' && (
              <div className="contract-details-outer">
                {typeof this.props.programInfo === 'object' && printHeader}
                <ProgramInfo {...props} />
                <hr />
                <Pricing {...props} hideCashDetails mini />
              </div>
            )}
            {activeSection === 'interactions' && (
              <div>
                <section className="dealer-summary-outer">
                  <DirtyMask {...props} />
                  <h2>Customer Info</h2>
                  <QuoteSaveForm
                    {...props}
                    intent={INTENTS.created}
                    className="dealer-create-form"
                  />

                  <div className="buttons submit-set dealer-submit-set inline">
                    <div className="submit-set-body">
                      {quoteShortLink && <SavedMessage {...this.props} />}
                      {quoteShortLink && (
                        <SavedMessage {...this.props} blinder />
                      )}

                      <VehicleLink {...this.props} />

                      <p>
                        {' '}
                        {quoteShortLink && (
                          <span className="short-link-display">
                            Direct link to this quote:{' '}
                            <a
                              href={quoteShortLink}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {quoteShortLink}
                            </a>
                          </span>
                        )}
                      </p>
                    </div>
                  </div>
                </section>

                {showInteractions && (
                  <section className="interactions-wrapper">
                    <h2>Customer Activity</h2>
                    <Interactions {...props} />
                  </section>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  return {
    ...op,
    activeSection: getQueryValue(state, 'dealtuner.section') || 'presentation',
    showInteractions: isQuotePersisted(state, op.vehicleId, op.quoteId),
    programInfo: get(
      getBestProgram(state, op.vehicleId, op.quoteId, op.mode),
      'programInfo',
    ),
    downPaymentUsage: getQuoteValue(
      state,
      op.vehicleId,
      op.quoteId,
      'downPaymentUsage',
    ),
    quoteShortLink: getQuoteShortLink(state, op.vehicleId, op.quoteId),
    isSelectedProgramExpired: isProgramExpired(
      state,
      op.vehicleId,
      op.quoteId,
      op.mode,
    ),
  }
}

export default connect(
  mapStateToProps,
  { updateQuote, addAndReplacePageState, removeFromPageState },
)(DealWorkArea)

/////////////////////////////////////
// TODO find a better home for these weird things
/////////////////////////////////////

export function TweakPreso(props) {
  let {
      adds,
      warranties,
      maintenancePlans,
      addItem,
      removeItem,
      updateQuote,
      vehicleId,
      quoteId,
      usingMdrive,
    } = props,
    editValue = s => (idx, fieldName, value) =>
      updateQuote(vehicleId, quoteId, {
        [`${s}[${idx}].${fieldName}`]: value,
      })

  return (
    <div className={c('quote-tweaks')}>
      <MaintenancePlans
        hideHelp
        hideRemove
        items={maintenancePlans}
        editValue={editValue}
        addItem={c => () => addItem(vehicleId, quoteId, c)}
        removeItem={c => idx => removeItem(vehicleId, quoteId, idx, c)}
        usingMdrive={usingMdrive}
      />
      <Warranties
        hideHelp
        hideRemove
        items={warranties}
        editValue={editValue}
        addItem={c => () => addItem(vehicleId, quoteId, c)}
        removeItem={c => idx => removeItem(vehicleId, quoteId, idx, c)}
        usingMdrive={usingMdrive}
      />
      <Additions
        hideHelp
        hideRemove
        items={adds}
        editValue={editValue}
        addItem={c => () => addItem(vehicleId, quoteId, c)}
        removeItem={c => idx => removeItem(vehicleId, quoteId, idx, c)}
        usingMdrive={usingMdrive}
      />
    </div>
  )
}

export function RebatesAndDiscountsPreso(props) {
  let {
      discounts,
      addItem,
      removeItem,
      updateQuote,
      vehicleId,
      quoteId,
      mode,
    } = props,
    editValue = s => (idx, fieldName, value) =>
      updateQuote(vehicleId, quoteId, {
        [`${s}[${idx}].${fieldName}`]: value,
      })

  return (
    <div className={c('quote-tweaks')}>
      <Rebates {...{ vehicleId, quoteId, mode }} hideDisclaimer />
      <br />
      <br />
      <Discounts
        hideHelp
        hideRemove
        items={discounts}
        editValue={editValue}
        addItem={c => () => addItem(vehicleId, quoteId, c)}
        removeItem={c => idx => removeItem(vehicleId, quoteId, idx, c)}
      />
    </div>
  )
}

export function FeesTweakPreso(props) {
  let { fees, addItem, removeItem, updateQuote, vehicleId, quoteId } = props,
    editValue = s => (idx, fieldName, value) =>
      updateQuote(vehicleId, quoteId, {
        [`${s}[${idx}].${fieldName}`]: value,
      })

  return (
    <div className={c('quote-tweaks', 'quote-tweaks-fees')}>
      <Fees
        hideHelp
        hideTitle
        hideRemove
        items={fees}
        editValue={editValue}
        addItem={c => () => addItem(vehicleId, quoteId, c)}
        removeItem={c => idx => removeItem(vehicleId, quoteId, idx, c)}
      />
    </div>
  )
}

function mapStateToProps2(state, op) {
  return {
    ...op,
    adds: getQuoteValue(state, op.vehicleId, op.quoteId, 'additions', []),
    warranties: getQuoteValue(
      state,
      op.vehicleId,
      op.quoteId,
      'warranties',
      [],
    ),
    maintenancePlans: getQuoteValue(
      state,
      op.vehicleId,
      op.quoteId,
      'maintenancePlans',
      [],
    ),
    discounts: getQuoteValue(state, op.vehicleId, op.quoteId, 'discounts', []),
    fees: getQuoteValue(state, op.vehicleId, op.quoteId, 'fees', []),
    usingMdrive: getHasMdrive(state),
  }
}

export const Tweak = connect(
  mapStateToProps2,
  { addItem, removeItem, updateQuote },
)(TweakPreso)

export const RebatesAndDiscounts = connect(
  mapStateToProps2,
  { addItem, removeItem, updateQuote },
)(RebatesAndDiscountsPreso)

export const FeesTweak = connect(
  mapStateToProps2,
  { addItem, removeItem, updateQuote },
)(FeesTweakPreso)

/////////////////////////////////////
